// src/components/PatioConfig.jsx
import React, { useState, useEffect } from 'react';
import api from '../services/api';
import { toast } from 'react-toastify';
import { FaDollarSign, FaSave, FaSpinner, FaCog, FaInfoCircle } from 'react-icons/fa';
import './PatioConfig.css';

export default function PatioConfig() {
    const [valorDiaria,  setValorDiaria]  = useState('');
    const [isLoading,    setIsLoading]    = useState(true);
    const [isSaving,     setIsSaving]     = useState(false);

    useEffect(() => {
        (async () => {
            setIsLoading(true);
            try {
                const { data } = await api.get('/api/config/patio/diaria');
                setValorDiaria(parseFloat(data.valor || 0).toFixed(2));
            } catch {
                toast.error('Não foi possível carregar o valor atual da diária.');
            } finally {
                setIsLoading(false);
            }
        })();
    }, []);

    const handleSave = async (e) => {
        e.preventDefault();
        const valorNumerico = parseFloat(valorDiaria);
        if (isNaN(valorNumerico) || valorNumerico < 0) {
            toast.warn('Insira um valor numérico positivo para a diária.');
            return;
        }
        setIsSaving(true);
        try {
            await api.put('/api/config/patio/diaria', { valor: valorNumerico });
            toast.success('Valor da diária salvo com sucesso!');
        } catch (err) {
            toast.error(err.response?.data?.error || 'Falha ao salvar o valor da diária.');
        } finally {
            setIsSaving(false);
        }
    };

    return (
        <div className="pc-container">
            <div className="pc-header">
                <div className="pc-header-icon"><FaCog /></div>
                <div>
                    <h1>Configuração do Pátio</h1>
                    <p>Parâmetros financeiros e operacionais do pátio</p>
                </div>
            </div>

            <div className="pc-card">
                <div className="pc-card-header">
                    <FaDollarSign className="pc-card-icon" />
                    <div>
                        <h3>Valor da Diária</h3>
                        <span>Cobrado por dia de permanência no pátio</span>
                    </div>
                </div>

                {isLoading ? (
                    <div className="pc-loading">
                        <FaSpinner className="spin" /> Carregando configuração...
                    </div>
                ) : (
                    <form onSubmit={handleSave} className="pc-form">
                        <div className="pc-form-group">
                            <label htmlFor="valorDiaria">Valor por dia</label>
                            <div className="pc-input-wrap">
                                <span className="pc-prefix">R$</span>
                                <input
                                    type="number"
                                    id="valorDiaria"
                                    value={valorDiaria}
                                    onChange={e => setValorDiaria(e.target.value)}
                                    step="0.01"
                                    min="0"
                                    required
                                    placeholder="0.00"
                                />
                            </div>
                        </div>

                        <div className="pc-info-box">
                            <FaInfoCircle />
                            Este valor é aplicado automaticamente ao calcular o total no momento do
                            check-out e na geração da primeira diária no check-in.
                            Cada tenant tem seu próprio valor configurável.
                        </div>

                        <div className="pc-form-footer">
                            <button type="submit" className="pc-btn-save" disabled={isSaving}>
                                {isSaving ? <><FaSpinner className="spin" /> Salvando...</> : <><FaSave /> Salvar Valor da Diária</>}
                            </button>
                        </div>
                    </form>
                )}
            </div>
        </div>
    );
}